// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "" + {"180":"video","303":"widget","495":"feed"}[chunkId] + "." + {"180":"26ed8aa8422fd0639e46","303":"8215a0c3381cc32a09eb","495":"ec60149fdec52219bff5"}[chunkId] + ".js";
};